import React from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import LoadingPage from "./LoadingPage";
import PageSix from "./PageSix";

const PageFive = () => {
    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={"Nama Sekolah"} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Summary Survei Karakter"} size={18} bolder={500} color={"#212529"} />
                        <LabelTitle label={"Profil Pelajar Pancasila"} size={14} bolder={400} color={"#212529"} />
                        <Gap height={20} />
                        <div className="rekap-table">
                            <Table striped size="sm" style={{ fontSize: 12 }}>
                                <thead
                                    style={{
                                        backgroundColor: "#E9ECEF",
                                        fontSize: 12,
                                        textAlign: "center",
                                    }}
                                >
                                    <tr>
                                        <th width="35%" height="50">
                                            Membudaya
                                        </th>
                                        <th width="35%">Baik</th>
                                        <th width="30%">Berkembang</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        height="40"
                                        style={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <td>
                                            <img
                                                src="/assets/image/bhineka-putih.png"
                                                width={20}
                                                style={{
                                                    marginBottom: 5,
                                                    marginTop: 5,
                                                }}
                                            />
                                            <LabelTitle label={"Bhineka"} size={11} bolder={400} color={"#6C757D"} />
                                            <p
                                                style={{
                                                    backgroundColor: "#0466C8",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 3,
                                                    width: "20%",
                                                    fontSize: 11,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "40%",
                                                    marginBottom: 5,
                                                }}
                                            >
                                                Score : 80
                                            </p>
                                        </td>
                                        <td>
                                            <img
                                                src="/assets/image/beriman-putih.png"
                                                width={20}
                                                style={{
                                                    marginBottom: 5,
                                                    marginTop: 5,
                                                }}
                                            />
                                            <LabelTitle label={"Beriman, Bertakwa kepada Tuhan YME, dan Berakhlak Mulia"} size={11} bolder={400} color={"#6C757D"} />
                                            <p
                                                style={{
                                                    backgroundColor: "#008000",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 3,
                                                    width: "20%",
                                                    fontSize: 11,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "40%",
                                                    marginBottom: 5,
                                                }}
                                            >
                                                Score : 80
                                            </p>
                                        </td>
                                        <td>
                                            <img
                                                src="/assets/image/mandiri-putih.png"
                                                width={20}
                                                style={{
                                                    marginBottom: 5,
                                                    marginTop: 5,
                                                }}
                                            />
                                            <LabelTitle label={"Mandiri"} size={11} bolder={400} color={"#6C757D"} />
                                            <p
                                                style={{
                                                    backgroundColor: "#FB8500",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 3,
                                                    width: "25%",
                                                    fontSize: 11,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "38%",
                                                    marginBottom: 5,
                                                }}
                                            >
                                                Score : 80
                                            </p>
                                        </td>
                                    </tr>
                                    <tr
                                        height="40"
                                        style={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <td>
                                            <img
                                                src="/assets/image/gotong-royong-putih.png"
                                                width={20}
                                                style={{
                                                    marginBottom: 5,
                                                    marginTop: 5,
                                                }}
                                            />
                                            <LabelTitle label={"Gotong Royong"} size={11} bolder={400} color={"#6C757D"} />
                                            <p
                                                style={{
                                                    backgroundColor: "#0466C8",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 3,
                                                    width: "20%",
                                                    fontSize: 11,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "40%",
                                                    marginBottom: 5,
                                                }}
                                            >
                                                Score : 80
                                            </p>
                                        </td>
                                        <td>
                                            <img
                                                src="/assets/image/bernalar-putih.png"
                                                width={20}
                                                style={{
                                                    marginBottom: 5,
                                                    marginTop: 5,
                                                }}
                                            />
                                            <LabelTitle label={"Bernalar"} size={11} bolder={400} color={"#6C757D"} />
                                            <p
                                                style={{
                                                    backgroundColor: "#008000",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 3,
                                                    width: "20%",
                                                    fontSize: 11,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "40%",
                                                    marginBottom: 5,
                                                }}
                                            >
                                                Score : 80
                                            </p>
                                        </td>
                                        <td>
                                            <img
                                                src="/assets/image/kreatif-putih.png"
                                                width={20}
                                                style={{
                                                    marginBottom: 5,
                                                    marginTop: 5,
                                                }}
                                            />
                                            <LabelTitle label={"Kreatif"} size={11} bolder={400} color={"#6C757D"} />
                                            <p
                                                style={{
                                                    backgroundColor: "#FB8500",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 3,
                                                    width: "25%",
                                                    fontSize: 11,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "38%",
                                                    marginBottom: 5,
                                                }}
                                            >
                                                Score : 80
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        <table style={{ fontSize: 10, width: "100%" }}>
                            <thead style={{ backgroundColor: "#E9ECEF", fontSize: 11, textAlign: "center" }}>
                                <tr>
                                    <th
                                        width="200"
                                        height="50"
                                        colSpan={2}
                                        style={{
                                            textAlign: "left",
                                            paddingLeft: 15,
                                        }}
                                    >
                                        Nama Siswa
                                    </th>
                                    <th>Nilai</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                                <tr width="100%" height="40" style={{ backgroundColor: "#F8F9FA", textAlign: "center" }}>
                                    <td>1</td>
                                    <td width="200" style={{ textAlign: "left" }}>
                                        Nama Siswa
                                    </td>
                                    <td>100</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>
                                        <div className="pagebreak-footer"></div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <Gap height={40} />
                {/* <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={"20/02/2022"} />
                </div> */}
            </div>

            {/* {openPage ? <PageSix /> : <LoadingPage />} */}
        </div>
    );
};

export default PageFive;
